import styles from './NavDrawer.scss';

import cx from 'classnames';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

export interface INavDrawer extends React.AllHTMLAttributes<HTMLDivElement> {
  open?: boolean;
}

export const CLOSED_CLASSNAME = cx(styles.navDrawer, styles.navDrawerClosed);

export const NavDrawer = React.forwardRef<HTMLDivElement, INavDrawer>(
({ open, children, className, ...props }, ref) => (
  <CSSTransition
    in={open}
    timeout={1000}
    classNames={{
      enter: cx(styles.navDrawer, styles.navDrawerOpen),
      enterDone: cx(styles.navDrawer, styles.navDrawerOpen, className),
      exit: CLOSED_CLASSNAME,
      exitDone: CLOSED_CLASSNAME,
    }}
  >
    <div ref={ref} className={cx({ [CLOSED_CLASSNAME] : !open, [styles.navDrawerOpen]: open })} {...props}>
      {children}
    </div>
  </CSSTransition>
));
